<template>
    <div>
        <NuxtLayout>
            <template #body_page>
                <CGTTopBar />
                <CGTHero />
                <CGTDifference />
                <CGTBenefits />
                <CGTHowItWorks />
                <TripsSection/>
                <CGTContact />
                <CGTFAQ />
            </template>
        </NuxtLayout>
        <ClientOnly>
        <teleport to="head">
            <component :is="'script'" type="application/ld+json">
                {{ ldJson }}
            </component>
        </teleport>
        </ClientOnly>
    </div>
</template>

<script setup>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import {debounceHeapTracking} from '~/mixins/heap'
import CGTTopBar from '~/components/pages/LandingPage/CGTTopBar'
import CGTHero from '~/components/pages/LandingPage/CGTHero/CGTHero.vue'
import CGTDifference from '~/components/pages/LandingPage/CGTDifference/CGTDifference.vue'
import CGTBenefits from '~/components/pages/LandingPage/CGTBenefits/CGTBenefits.vue'
import CGTContact from '~/components/pages/LandingPage/CGTContact.vue'
import CGTHowItWorks from '~/components/pages/LandingPage/CGTHowitWorks/CGTHowItWorks.vue'
import CGTFAQ from '~/components/pages/LandingPage/CGTFAQ/CGTFAQ.vue'
import { onMounted } from 'vue'
import TripsSection from '~/components/pages/LandingPage/SchoolTrips/TripsSection.vue'
import { SCHOOL_CONTACT_LINK } from '~/constant/schoolTourDetails'

onMounted(() => {
  debounceAmplitudeScriptTracking("View school tours")
  debounceHeapTracking("View school tours")
})

const ldJson = {
    '@type': 'WebSite',
    '@id': 'https://www.designerjourneys.com/school-tour-details/#website',
    url: 'https://www.designerjourneys.com/school-tour-details',
    name: 'Designer Journeys School Tours',
    description:
        'Unlock extraordinary experiences and memorable school tours. Enjoy hassle-free planning with Designer Journeys fully managed service.',
    potentialAction: [
        {
            '@type': 'AskAction',
            name: 'Start Designing The Perfect School Trip',
            target: {
                '@type': 'EntryPoint',
                urlTemplate: `${SCHOOL_CONTACT_LINK}`,
                inLanguage: 'en-US',
                actionPlatform: [
                    'http://schema.org/DesktopWebPlatform',
                    'http://schema.org/MobileWebPlatform',
                ],
            },
        },
    ],
    inLanguage: 'en-US',
}
</script>

<style lang="scss" scoped></style>
